import React from 'react'
import Skeleton from 'react-loading-skeleton'
import mainData from '../../FetchDataLinks'
import UseFetch from '../../UseFetch'
import CateogaryLI from './CateogaryLI'

function Cateogaries() {
    const { blogs, loading } = UseFetch(mainData.famous)

    let a = 0;

    return (
        <div className="sidebar-widget sidebar-blog-category">
            <div className="sidebar-title">
                <h4>Categories</h4>
            </div>
            <ul className="blog-cat">

                {!loading && blogs.map((blog) => {
                    return <CateogaryLI key={blog.id} cateogary={blog.Cateogary} />
                })}

                {loading && Array(4).fill().map(() => {
                    a++;
                    return <li key={`skeleton${a}`} ><a href={`/cateogary/`}><Skeleton /></a></li>
                })}
            </ul>
        </div>
    )
}

export default Cateogaries
